import {DocumentiStoreService} from './../_services/documenti-store.service';
import {ApiRestService} from './../_services/api-rest.service';
import {ProdottiStoreService} from '../_services/prodotti-store.service';
import {Categorie} from './../Models/Categorie';
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {RicercaPaginazione} from 'src/app/Admin/models/sendpersonale';
import {IDropdownSettings} from 'ng-multiselect-dropdown';
import {ActivatedRoute, Router} from '@angular/router';
import {Permission} from "../../Login/_guards/Permission";
import {ToastrService} from "ngx-toastr";
import {environment} from "../../../environments/environment";
import {ApiPathsService} from "../../api-paths.service";

@Component({
  selector: 'app-Documenti',
  templateUrl: './Documenti.component.html',
  styleUrls: ['./Documenti.component.scss']
})
export class DocumentiComponent implements OnInit {
  Env = environment;
  categoriedropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    textField: 'categoria',
    searchPlaceholderText: "inserire almeno 3 caratteri",
    allowSearchFilter: true,
    allowRemoteDataSearch: true,
  };
  sel_cat_id: number = 0;
  sezione: number = 0;
  type;
  section;
  CategoriaDaModificare: Categorie = null;
  LabelCategoria: string = "";
  showMenu = '';
  showSubMenu = '';
  modificheAbilitate: boolean = false;
  CategorieLineare: Categorie[] = [];
  CategorieSelezionate: Categorie[] = [];
  public sidebarnavItems: Categorie[] = []
  path = '';
  createButtonClick = true;
  
  @Input() HideCat: boolean = false;
  @Input() showClass: boolean = false;
  @Output() notify: EventEmitter<boolean> = new EventEmitter<boolean>();
  Ordine: number;


  handleNotify() {
    this.notify.emit(!this.showClass);
  }

  constructor(
    private toastService: ToastrService,
    private documentiStore: DocumentiStoreService,
    private modalService: NgbModal,
    private apirest: ApiRestService,
    public router: Router,
    private route: ActivatedRoute,
    public apiPaths: ApiPathsService,
    public permission: Permission
  ) {
    this.documentiStore.getCategorie();
    this.documentiStore.$categorieCercate.subscribe(data => {
      if (data !== null)
        this.CategorieLineare = data;
    });
  }

  ngOnInit() {
    this.route.params.subscribe(data => {
      this.type = data['type']; 
      this.section = data['sezione']; 
      this.HideCat = this.HideCat || (data['nocat'] == '1')

      console.log("Url Data: ", data);
      if (!isNaN(parseInt(this.type)) || !isNaN(parseInt(this.section))){
        this.sel_cat_id = parseInt(this.type);
        this.sezione = parseInt(this.section);
      }
      this.Refresh();

    })
    
  }

  Refresh(){
    this.documentiStore.$categorie.subscribe(data => {
        
      var result =  this.sezione ? data?.find(x=>x.id == this.sezione)?.figli ?? [] : data;
      this.sidebarnavItems = result;
      console.log('Items', this.sidebarnavItems);
    });

  }

  AbilitaModifiche() {
    this.modificheAbilitate = !this.modificheAbilitate;
  }

  Elimina(value: Categorie) {
    if (confirm("Sei sicuro di voler eliminare questa categoria?")) {
      this.apirest.deleteCategorieDocumento(value).subscribe(data => {
        this.documentiStore.getCategorie();
      })
    }
  }

  filtroCategoria(item: string) {
    this.documentiStore.getCategorie(new RicercaPaginazione(item, undefined, undefined));
  }

  clicked(cat: Categorie) {
    if (cat && !isNaN(cat.id)) {
      this.sel_cat_id = cat.id;
      console.log(this.sel_cat_id)
      var sezioneStringa = this.sezione && this.sezione != 0 ? `${this.sezione.toString()}/` :''
      var catStringa = `${cat?.id?.toString() ?? ''}/`
      var nocat = this.HideCat ?  '1/': ''
      var Url = `progetti/documenti/${sezioneStringa}${nocat}lista/${catStringa}`

      this.router.navigate([this.route.snapshot.queryParams[Url] || Url])

      // if(this.sezione != 0){
      //     this.router.navigate([this.route.snapshot.queryParams[`progetti/documenti/${this.sezione.toString()}/lista/${cat.id.toString()}`] || `progetti/documenti/${this.sezione.toString()}/lista/${cat.id.toString()}`]);
      // }
      // else{
      //   console.log(this.sezione)
      //   this.router.navigate([this.route.snapshot.queryParams[`progetti/documenti/lista/${cat.id.toString()}`] || `progetti/documenti/lista/${cat.id.toString()}`,]);
      // }
        //this.router.navigate([this.route.snapshot.queryParams[`progetti/documenti/lista/${cat.id.toString()}/${this.sidebarnavItems[0].id.toString()}`] || `progetti/documenti/lista/${cat.id.toString()}/${this.sidebarnavItems[0].id.toString()}`,]);
      //}
      //else

    }
  }


  openModal(targetModal: NgbModal, selected: Categorie, selectedParent: Categorie) {
    this.modalService.open(targetModal, {centered: true, backdrop: 'static'});
    this.CategoriaDaModificare = selected ?? new Categorie();
    this.CategorieSelezionate = selectedParent ? [selectedParent] : [];
    this.LabelCategoria = selected ? selected.categoria : "";
    this.Ordine = selected ? selected.ordine : 0;
  }

  async immaginecambiata(event) {
    const file: Blob = event.target.files[0];
    if (!file.type.includes("image")) {
      this.toastService.warning("Questo formato non è supportato. Inserire solo immagini.", "Attenzione!")
      return;
    }
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.CategoriaDaModificare.immagine = reader?.result?.toString()?.length > 1 ? reader.result.toString() : undefined;
      this.CategoriaDaModificare.file = reader?.result?.toString()?.length > 1 ? event.target.files[0].name : this.CategoriaDaModificare.file;
    };
  }

  saveModalButton() {
    if (this.CategoriaDaModificare !== null) {
      const updateData = this.CategoriaDaModificare;

      updateData.categoria = this.LabelCategoria;
      updateData.cat_id = this.CategorieSelezionate != null && this.CategorieSelezionate.length > 0 ? this.CategorieSelezionate[0].id : undefined;
      updateData.ordine = this.Ordine;
      if (this.CategoriaDaModificare.id)
        this.apirest.updateCategorieDocumento(updateData).subscribe(() => this.modalClose());
      else
        this.apirest.addCategorieDocumento(updateData).subscribe(() => this.modalClose());
    }
  }
  save(Cat) {
    if (Cat !== null) {
      const updateData = Cat;

    
      if (Cat.id)
        this.apirest.updateCategorieDocumento(updateData).subscribe(() => this.modalClose());
      else
        this.apirest.addCategorieDocumento(updateData).subscribe(() => this.modalClose());
    }
  }

  modalClose() {
    this.documentiStore.getCategorie();
    this.closeBtnClick()
  }

  deleteModalButton() {
    if (confirm("Sei sicuro di voler eliminare questo elemento ?")) {
      const updateData = new Categorie();
      updateData.id = this.CategoriaDaModificare.id;
      if (this.CategorieSelezionate != null && this.CategorieSelezionate.length > 0)
        updateData.cat_id = this.CategorieSelezionate[0].id;
      else
        updateData.cat_id = undefined;
      this.apirest.deleteCategorieDocumento(updateData).subscribe(data => {
        this.documentiStore.getCategorie();
        this.closeBtnClick()
      });
    }
  }

  closeBtnClick() {
    this.modalService.dismissAll();
    //this.ngOnInit();
  }
}
